import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import composition from '@/composition';
import { qtLike } from '@/composition/qt';
import ua from '@/utils/platform';
export default {
  props: {
    item: Object
  },

  setup(__props) {
    const props = __props;
    const {
      loginHandle,
      ref,
      request,
      throttle,
      openApp,
      getAppSearch
    } = composition();

    const toApp = () => {
      if (ua.isAndroid) {
        getAppSearch();
      } else if (ua.isIOS) {
        openApp();
      }
    };

    const record = ref({ ...props.item
    }); // 点赞操作

    const likeAction = throttle(() => {
      _Toast.loading({
        message: '操作中...',
        duration: 0,
        forbidClick: true
      });

      let isLove = true;

      if (record.value.loveState == true) {
        // 已点赞
        isLove = false;
      }

      loginHandle().then(() => {
        request.likePost(record.value.id, isLove).then(() => {
          qtLike(props.item);

          _Toast({
            message: isLove ? '点赞成功' : '取消点赞成功',
            position: 'bottom'
          });

          record.value.loveState = isLove;

          if (isLove) {
            record.value.loveCount++;
          } else {
            record.value.loveCount--;
          }
        }).catch(error => {
          _Toast.fail(error.message);
        });
      }).catch(() => {
        _Toast.fail('操作失败');
      });
      pocPostLove(isLove);
    }); // [埋点] 点击点赞按钮

    const pocPostLove = (isLove, item = props.item) => {
      const isMini = ua.isMini;
      const eventName = isMini ? 'fsplusmp_thumpsup_click' : 'fsplush5_thumpsup_click';
      let _poc_event_params = {
        button_name: isMini ? '帖子详情页' : undefined,
        // 内嵌小程序时才上报此字段
        content_id: item.id,
        toggle_on: isLove,
        user_code: item.memberId,
        author_name: item.memberNickname
      }; // eslint-disable-next-line no-undef

      qaplus.event.record(eventName, 2101, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record(eventName, _poc_event_params);
    };

    return (_ctx, _cache) => {
      return _unref(ua).isFsPlus ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(likeAction) && _unref(likeAction)(...args))
      }, [_renderSlot(_ctx.$slots, "main", {
        record: record.value
      })])) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: toApp
      }, [_renderSlot(_ctx.$slots, "main", {
        record: record.value
      })]));
    };
  }

};